import { Moment } from 'moment-timezone';

export interface IntakeFormPreferences {
    enabled: boolean;
    questionsEnabled: boolean;
    questions: Array<IntakeFormCustomQuestion>;
}

export interface IntakeFormCustomQuestion {
    id: number;
    order: number;
    question: string;
    isEnabled: boolean;
    isRequired: boolean;
    marketplaceId: number;
    category: IntakeFormCustomQuestionCategory;
    createdAt: Moment;
    updatedAt: Moment;
}

export enum IntakeFormCustomQuestionCategory {
    FOR_CUSTOMER = 'for_customers',
    FOR_PET = 'for_pets'
}

export interface IntakeFormCustomQuestionAnswer {
    answer: string;
    question: string;
    questionId: number;
}
